import MuiInputLabel from "@mui/material/InputLabel";
const InputLabel = MuiInputLabel;
export default InputLabel;
